import React from "react";
import PickerChips from "../../../../components/ui/PickerChips";
import { EVALUATION_TYPES } from "../templateUtils";

const Switch = ({ id, checked, onChange, label, hint }) => (
  <div className="form-check form-switch">
    <input
      id={id}
      type="checkbox"
      className="form-check-input"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
    />
    <label htmlFor={id} className="form-check-label fs-085">
      {label}
      {hint && <span className="d-block text-slate-500 fs-075">{hint}</span>}
    </label>
  </div>
);

/** Code, name, who the form is for, and the self-assessment / acknowledgement switches. */
const GeneralCard = ({
  form,
  update,
  isCreate,
  readOnly,
  companies,
  roleOptions,
  jobTitleOptions,
}) => (
  <section className="builder-card" aria-labelledby="general-title">
    <h2 id="general-title" className="builder-card-title">
      <i className="bi bi-info-circle"></i> General
    </h2>
    <div className="row g-3">
      <div className="col-md-4">
        <label htmlFor="tpl-code" className="profile-label">
          Code <span className="text-danger">*</span>
        </label>
        <input
          id="tpl-code"
          className="form-control text-uppercase"
          value={form.code}
          maxLength={30}
          onChange={(e) =>
            update({
              code: e.target.value.toUpperCase().replace(/[^A-Z0-9_-]/g, ""),
            })
          }
          placeholder="GM-EVAL"
          disabled={!isCreate}
        />
        <div className="text-slate-500 fs-070 mt-1">
          {isCreate
            ? "Groups all versions. Can't be changed later."
            : "Can't be changed."}
        </div>
      </div>
      <div className="col-md-8">
        <label htmlFor="tpl-name" className="profile-label">
          Name <span className="text-danger">*</span>
        </label>
        <input
          id="tpl-name"
          className="form-control"
          value={form.name}
          onChange={(e) => update({ name: e.target.value })}
          placeholder="General Manager Performance Evaluation"
        />
      </div>
      <div className="col-12">
        <label htmlFor="tpl-desc" className="profile-label">
          Description
        </label>
        <textarea
          id="tpl-desc"
          className="form-control"
          rows={2}
          value={form.description}
          onChange={(e) => update({ description: e.target.value })}
        />
      </div>

      <div className="col-md-6">
        <span className="profile-label" id="tpl-type-label">
          Evaluation type
        </span>
        <div
          className="segmented"
          role="radiogroup"
          aria-labelledby="tpl-type-label"
        >
          {EVALUATION_TYPES.map((t) => (
            <button
              key={t}
              type="button"
              role="radio"
              aria-checked={form.evaluationType === t}
              className={`segmented-option ${form.evaluationType === t ? "active" : ""}`}
              onClick={() => update({ evaluationType: t })}
            >
              {t}
            </button>
          ))}
        </div>
        <div className="text-slate-500 fs-070 mt-1">
          Which employees: internal staff, deployed staff, or both.
        </div>
      </div>
      <div className="col-md-6">
        <label htmlFor="tpl-company" className="profile-label">
          Company
        </label>
        <select
          id="tpl-company"
          className="form-select"
          value={form.companyId}
          onChange={(e) => update({ companyId: e.target.value })}
        >
          <option value="">All companies</option>
          {companies.map((c) => (
            <option key={c.id} value={c.id}>
              {c.companyName || c.name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-6">
        <label htmlFor="tpl-roles" className="profile-label">
          Applies to roles
        </label>
        <PickerChips
          id="tpl-roles"
          options={roleOptions}
          value={form.appliesTo.roleIds}
          onChange={(roleIds) =>
            update({ appliesTo: { ...form.appliesTo, roleIds } })
          }
          placeholder="Add role…"
          emptyText="Any role"
          readOnly={readOnly}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="tpl-jobtitles" className="profile-label">
          Applies to job titles
        </label>
        <PickerChips
          id="tpl-jobtitles"
          options={jobTitleOptions}
          value={form.appliesTo.jobTitleIds}
          onChange={(jobTitleIds) =>
            update({ appliesTo: { ...form.appliesTo, jobTitleIds } })
          }
          placeholder="Add job title…"
          emptyText="Any job title"
          readOnly={readOnly}
        />
      </div>

      <div className="col-md-6">
        <Switch
          id="tpl-self"
          checked={form.allowSelfAssessment}
          onChange={(v) => update({ allowSelfAssessment: v })}
          label="Allow self-assessment"
          hint="The employee rates themselves before the evaluator. Every result then goes to the employee to agree or contest."
        />
      </div>
    </div>
  </section>
);

export default GeneralCard;
